import * as React from 'react';
import { useContext, useState } from 'react';
import { NavLink, useLocation, useMatch } from 'react-router-dom';
import { linksForKnowledgeBase } from '../helpers/header/links_for_knowledge_base';
import { Divider } from './common/divider';
import { UserContext } from './contexts/user_context';
import Bed from './icons/bed';
import Calendar from './icons/calendar';
import { Channels } from './icons/channels';
import CheckCircle from './icons/check_circle';
import ClipboardAccount from './icons/clipboard_account';
import Expand from './icons/expand';
import Gallery from './icons/gallery';
import Group from './icons/group';
import Home from './icons/home';
import Knowledge from './icons/knowledge';
import { List } from './icons/list';
import Monetization from './icons/monetization';
import OpenInNew from './icons/open_in_new';
import QuestionAnswer from './icons/question_answer';
import Today from './icons/today';

export const ICON_COLOR = 'rgba(0, 0, 0, 0.64)';

export interface MenuProps {
  onGoTo?: (event: React.MouseEvent) => void;
}

export const Menu: React.FC<MenuProps> = (props) => {
  const [tariffsOpen, setTariffsOpen] = useState(false);
  const [campOpen, setCampOpen] = useState(false);
  const [financesOpen, setFinancesOpen] = useState(false);
  const tariffsMatch = useMatch('/tariffs/*');
  const tariffsPricesMatch = useMatch('/tariffs/prices');
  const tariffsActive = !!tariffsMatch && !tariffsPricesMatch;
  const campActive = useMatch('/camp*');
  const financesActive = useMatch('/finances*');
  const userContext = useContext(UserContext);
  const pathname = useLocation().pathname;
  const anotherknowLedgeLinks = ['/channel_manager'];
  const knowLedgeLink = anotherknowLedgeLinks.includes(pathname)
    ? linksForKnowledgeBase.get(pathname)
    : '/knowledge_base';

  const handleClickMenuItem = (event: React.MouseEvent) => {
    if (userContext.sign_in_url) {
      event.preventDefault();
      window.location.href = userContext.sign_in_url;
    } else {
      props.onGoTo?.(event);
    }
  };

  return (
    <div className={'menu__wrapper'}>
      <NavLink to={'/'} className={'menu__item'} onClick={handleClickMenuItem}>
        <Home color={ICON_COLOR} />
        Сводка
      </NavLink>
      <NavLink to={'/bookings'} className={'menu__item'} onClick={handleClickMenuItem}>
        <Today color={ICON_COLOR} />
        Бронирования
      </NavLink>
      <NavLink to='/tariffs/prices' className='menu__item' onClick={handleClickMenuItem}>
        <List color={ICON_COLOR} />
        Цены и ограничения
      </NavLink>
      <div className={`menu__item-with_children ${(tariffsOpen || tariffsActive) && 'menu__item-opened'}`}>
        <div className={'menu__item'} onClick={() => setTariffsOpen(!tariffsOpen)}>
          <Bed color={ICON_COLOR} />
          <div className={'menu__item_name'}>Номера и тарифы</div>
          <Expand color={ICON_COLOR} className={'menu__item_expand'} />
        </div>
        <div className={`menu__item-children ${tariffsOpen || tariffsActive ? 'menu__item-children_opened' : ''}`}>
          <NavLink to='/tariffs/apartments' className='menu__item' onClick={handleClickMenuItem}>
            Категории номеров
          </NavLink>
          <NavLink to='/tariffs/rooms' className='menu__item' onClick={handleClickMenuItem}>
            Доступность номеров
          </NavLink>
          <NavLink to='/tariffs' className='menu__item' end onClick={handleClickMenuItem}>
            Тарифы
          </NavLink>
        </div>
      </div>
      {userContext.current_camp?.show_planning && (
        <NavLink to={'/planning'} className={'menu__item'} onClick={handleClickMenuItem}>
          <Calendar color={ICON_COLOR} />
          Шахматка броней
        </NavLink>
      )}
      <NavLink to={'/reviews'} className={'menu__item'} onClick={handleClickMenuItem}>
        <QuestionAnswer color={ICON_COLOR} />
        Отзывы
      </NavLink>
      <NavLink to={'/gallery'} className={'menu__item'} onClick={handleClickMenuItem}>
        <Gallery color={ICON_COLOR} />
        Фотографии
      </NavLink>
      <div className={`menu__item-with_children ${(campOpen || campActive) && 'menu__item-opened'}`}>
        <div className={'menu__item'} onClick={() => setCampOpen(!campOpen)}>
          <Bed color={ICON_COLOR} />
          <div className={'menu__item_name'}>Объект</div>
          <Expand color={ICON_COLOR} className={'menu__item_expand'} />
        </div>
        <div className={`menu__item-children ${campOpen || campActive ? 'menu__item-children_opened' : ''}`}>
          <NavLink to={'/camp/cancellation_rules'} className={'menu__item'} onClick={handleClickMenuItem}>
            Аннуляция и штрафы
          </NavLink>
          <NavLink to={'/camp/services'} className={'menu__item'} onClick={handleClickMenuItem}>
            Удобства и услуги
          </NavLink>
          <NavLink to={'/camp/medical_services'} className={'menu__item'} onClick={handleClickMenuItem}>
            Медицинские услуги
          </NavLink>
          <NavLink to={'/camp/info'} className={'menu__item'} end onClick={handleClickMenuItem}>
            Реквизиты
          </NavLink>
          <NavLink to={'/camp/contracts'} className={'menu__item'} onClick={handleClickMenuItem}>
            Договор
          </NavLink>
          <NavLink to={'/camp/settings'} className={'menu__item'} onClick={handleClickMenuItem}>
            Настройки объекта
          </NavLink>
        </div>
      </div>
      <div className={`menu__item-with_children ${(financesOpen || financesActive) && 'menu__item-opened'}`}>
        <div className={'menu__item'} onClick={() => setFinancesOpen(!financesOpen)}>
          <Monetization />
          <div className={'menu__item_name'}>Финансы</div>
          <Expand color={ICON_COLOR} className={'menu__item_expand'} />
        </div>
        <div className={`menu__item-children ${financesOpen || financesActive ? 'menu__item-children_opened' : ''}`}>
          <NavLink to={'/finances/agent_report'} className={'menu__item'} onClick={handleClickMenuItem}>
            Отчеты агента
          </NavLink>
          <NavLink to={'/finances/reconciliation_report'} className={'menu__item'} onClick={handleClickMenuItem}>
            Сверка
          </NavLink>
        </div>
      </div>
      <NavLink to={'/contacts'} className={'menu__item'} onClick={handleClickMenuItem}>
        <ClipboardAccount />
        Контакты
      </NavLink>
      <NavLink to={'/channel_manager'} className={'menu__item'} onClick={handleClickMenuItem}>
        <Channels />
        {userContext.current_camp?.channel_manager?.name ? (
          <>
            {userContext.current_camp.channel_manager.name}
            <CheckCircle size={14} />
          </>
        ) : (
          'Менеджер каналов'
        )}
      </NavLink>
      <NavLink to={'/accounts'} className={'menu__item'} onClick={handleClickMenuItem}>
        <Group />
        Пользователи
      </NavLink>
      <Divider outerPadding={0} marginVertical={16} />
      <NavLink to={'/more_clients'} className={'menu__item'} onClick={handleClickMenuItem}>
        <OpenInNew />
        Привлечь клиентов
      </NavLink>
      <NavLink to={knowLedgeLink} className={'menu__item'} onClick={handleClickMenuItem}>
        <Knowledge />
        База знаний
      </NavLink>
    </div>
  );
};
